// Версия клиента для сервера: заголовок `X-Client-Version` (T-041).
//
// Нужна аналитике платформы — «кто сидит на старой версии». Две версии, потому что
// отстают они по-разному: веб-слой обновляется сам по воздуху, а оболочка (APK,
// Electron) — только переустановкой.
//
// Значение вычисляется один раз при старте (`appUpdate/clientVersion.ts`) и лежит здесь,
// в памяти модуля, как токен: httpClient читает его синхронно. Пока не вычислено —
// заголовка нет; запрос из-за этого не ждёт и не отклоняется.

export type ClientPlatform = 'android' | 'windows' | 'browser';

let cached: string | null = null;

/** `android/0.2.10;web/0.2.13`; без версии оболочки — `windows;web/0.2.13`. */
export function formatClientVersion(
  platform: ClientPlatform,
  shell: string | null,
  web: string,
): string {
  return `${platform}${shell ? `/${shell}` : ''};web/${web}`;
}

export function setClientVersion(value: string | null): void {
  cached = value;
}

export function clientVersionHeader(): Record<string, string> {
  return cached ? { 'X-Client-Version': cached } : {};
}
